import { IApplicationState } from '../../types/redux';

export function getNewbuildingBlackFridayUrl(state: IApplicationState) {
  return state.config.newbuildingBlackFriday.url || '';
}
